var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGraph(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 392.598 392.598",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#ffc10d",
    d: "M92.768 207.257h31.806v163.556H92.768z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M200.986 94.513h31.806v276.299h-31.806z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#56ace0",
    d: "M309.139 37.689h31.806v333.123h-31.806z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M381.673 370.812h-18.877V26.764c0-6.012-4.848-10.925-10.925-10.925h-53.657c-6.012 0-10.925 4.848-10.925 10.925v344.048h-32.711V83.588c0-6.012-4.848-10.925-10.925-10.925h-53.721c-6.012 0-10.925 4.848-10.925 10.925v287.224H146.49V196.331c0-6.012-4.848-10.925-10.925-10.925H81.842c-6.012 0-10.925 4.848-10.925 10.925v174.481H21.786V10.925C21.786 4.913 16.937 0 10.861 0S0 4.913 0 10.925v370.747c0 6.012 4.848 10.925 10.925 10.925h370.747c6.012 0 10.925-4.848 10.925-10.925-.064-6.011-4.912-10.86-10.924-10.86zm-257.035 0H92.832V207.257h31.806v163.555zm108.154 0h-31.806V94.513h31.806v276.299zm108.218 0h-31.806V37.689h31.806v333.123z",
    fill: "#194f82"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGraph);
export default __webpack_public_path__ + "static/media/Graph.69c5f9b3.svg";
export { ForwardRef as ReactComponent };